import { Component } from '@angular/core';

@Component({
  standalone: true,
    selector: 'app-novo-cadastro-publicidade-check',
    imports: [],
    templateUrl: './novo-cadastro-publicidade-check.component.html',
    styleUrl: './novo-cadastro-publicidade-check.component.scss'
})
export class NovoCadastroPublicidadeCheckComponent {

}
